import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ea13dea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ws_select" }
const _hoisted_2 = {
  key: 1,
  class: "location"
}
const _hoisted_3 = { class: "ws_common_operation divider ws_pb30" }
const _hoisted_4 = { class: "ws_common_operation ws_mt30 ws_mb24" }
const _hoisted_5 = { class: "switch ws_mr10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "包含详情", -1))
const _hoisted_7 = { class: "ws_mb15" }
const _hoisted_8 = { class: "ws_drawer_footer" }

import { ref, computed, watch } from 'vue'
import { cloneDeep, isEmpty } from 'lodash'
import {
  querySatelliteTreeList,
  querySatelliteTle,
  queryDictionaryTreeList,
  queryDictionaryPass,
  exportDictionaryPass,
} from '@/api'
import { CODE_ENUM } from '@/common'
import { downLoadFile } from '@/utils'
import { ElMessage } from 'element-plus'
import moment from 'moment'
import Text from '@/components/text'
import MapModal from '@/components/map-modal-drawer'


export default /*#__PURE__*/_defineComponent({
  __name: 'prediction-drawer',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-map-change'],
  setup(__props, { emit: __emit }) {

const props = __props
const $emit = __emit

const formRef = ref()

const STATION_ENUM = {
  STATION: 'STATION',
  CUSTOM: 'CUSTOM',
}

const formData = ref({
  type: STATION_ENUM.STATION,
  time: [],
  stationId: '',
  satelliteCodeList: [],
  calculationElevation: undefined,
  forecastDays: undefined,
  timeZone: undefined,
})

const detailFlag = ref(false)

const utcOps = [
  {
    label: 'UTC-12',
    value: -12,
  },
  {
    label: 'UTC-11',
    value: -11,
  },
  {
    label: 'UTC-10',
    value: -10,
  },
  {
    label: 'UTC-09',
    value: -9,
  },
  {
    label: 'UTC-08',
    value: -8,
  },
  {
    label: 'UTC-07',
    value: -7,
  },
  {
    label: 'UTC-06',
    value: -6,
  },
  {
    label: 'UTC-05',
    value: -5,
  },
  {
    label: 'UTC-04',
    value: -4,
  },
  {
    label: 'UTC-3',
    value: -3,
  },
  {
    label: 'UTC-2',
    value: -2,
  },
  {
    label: 'UTC-1',
    value: -1,
  },
  {
    label: 'UTC+0',
    value: 0,
  },
  {
    label: 'UTC+1',
    value: 1,
  },
  {
    label: 'UTC+2',
    value: 2,
  },
  {
    label: 'UTC+3',
    value: 3,
  },
  {
    label: 'UTC+4',
    value: 4,
  },
  {
    label: 'UTC+5',
    value: 5,
  },
  {
    label: 'UTC+6',
    value: 6,
  },
  {
    label: 'UTC+7',
    value: 7,
  },
  {
    label: 'UTC+8',
    value: 8,
  },
  {
    label: 'UTC+9',
    value: 9,
  },
  {
    label: 'UTC+10',
    value: 10,
  },
  {
    label: 'UTC+11',
    value: 11,
  },
  {
    label: 'UTC+12',
    value: 12,
  },
  {
    label: 'UTC+13',
    value: 13,
  },
  {
    label: 'UTC+14',
    value: 14,
  },
]

// const getEndTime = (data: any) => {
//   const { startTime, forecastDays } = data
//   if (startTime && forecastDays) {
//     return moment(startTime)
//       .add(forecastDays, 'day')
//       .format('YYYY-MM-DD HH:mm:ss')
//   }
//   return '-'
// }

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      querySatelliteList()
      queryDictionaryList()
    }
  }
)

const col: any = ref([
  {
    type: 'index',
    label: '序号',
    width: 60,
    fixed: 'left',
  },
  {
    prop: 'startTime',
    label: '入境时间',
    width: '200',
    formatter: ({ startTime }: any) => {
      return moment(startTime).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  {
    prop: 'satelliteName',
    label: '卫星名称',
    width: '180',
  },
  {
    prop: 'satelliteCode',
    label: '卫星ID',
  },
  {
    prop: 'endTime',
    label: '出境时间',
    width: '200',
    formatter: ({ endTime }: any) => {
      return moment(endTime).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  {
    prop: 'duration',
    label: '入境时长',
    width: '180',
  },
  {
    prop: 'maxElevationTime',
    label: '最大俯仰角时间',
    width: '200',
    formatter: ({ maxElevationTime }: any) => {
      return moment(maxElevationTime).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  {
    prop: 'maxElevation',
    label: '最大俯仰角',
    width: '200',
  },
])

const validateType = (rules: any, value: any, callback: any) => {
  if (value === STATION_ENUM.STATION && !formData.value.stationId) {
    callback('请选择')
    return
  }
  if (value === STATION_ENUM.CUSTOM && !mapData.value.lat) {
    callback('请选择')
    return
  }
  callback()
}

const rules: any = {
  type: [{ validator: validateType }, { required: true, message: '请选择' }],
  satelliteCodeList: [{ required: true, message: '请选择', type: 'array' }],
  calculationElevation: [{ required: true, message: '请输入' }],
  forecastDays: [{ required: true, message: '请输入' }],
  time: [{ required: true, message: '请选择' }],
}

const submit = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      handleAPI()
    }
  })
}

const moFormData: any = ref({})
const tableData: any = ref([])
const tableLoading = ref(false)
const handleAPI = async () => {
  tableLoading.value = true
  const {
    time,
    forecastDays,
    stationId,
    type,
    calculationElevation,
    satelliteCodeList,
    timeZone,
  } = formData.value

  const { lat, lng } = mapData.value
  const params =
    type === STATION_ENUM.STATION
      ? { stationId }
      : {
          latitude: lat,
          longitude: lng,
        }
  const [startTime, endTime] = time

  const res: any = await queryDictionaryPass({
    ...params,
    satelliteCodeList,
    timeZone,
    calculationElevation,
    startTime: moment(startTime).valueOf(),
    endTime: moment(endTime).valueOf(),
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res.data || []
    moFormData.value = cloneDeep(formData.value)
    moMapData.value = cloneDeep(mapData.value)
  }
}

const handleClose = () => {
  $emit('update:visible', false)
  formRef.value?.resetFields?.()
  tableData.value = []
  mapData.value = {
    address: '',
    lng: '',
    lat: '',
  }
  formData.value = {
    type: STATION_ENUM.STATION,
    time: [],
    stationId: '',
    satelliteCodeList: [],
    calculationElevation: undefined,
    forecastDays: undefined,
    timeZone: undefined,
  }
}

const satelliteList: any = ref([])
const querySatelliteList = async () => {
  const res: any = await querySatelliteTreeList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    satelliteList.value = res.data || []
  }
}

const dictionaryList: any = ref([])
const queryDictionaryList = async () => {
  const res: any = await queryDictionaryTreeList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    dictionaryList.value = res.data || []
  }
}

const exportTable = async () => {
  const {
    time,
    forecastDays,
    stationId,
    type,
    calculationElevation,
    satelliteCodeList,
    timeZone,
  } = moFormData.value

  const { lat, lng } = moMapData.value
  const params =
    type === STATION_ENUM.STATION
      ? { stationId }
      : {
          latitude: lat,
          longitude: lng,
        }

  const [startTime, endTime] = time
  const res: any = await exportDictionaryPass({
    ...params,
    satelliteCodeList,
    calculationElevation,
    startTime: moment(startTime).valueOf(),
    endTime: moment(endTime).valueOf(),
    detailFlag: detailFlag.value,
    timeZone,
  })
  if (res?.msg?.code === CODE_ENUM.SUCCESS) {
    downLoadFile(res)
  } else {
    ElMessage.error(res?.msg?.msg)
  }
}

const moMapData: any = ref({})
const mapData: any = ref({
  address: '',
  lng: '',
  lat: '',
})
const mapConf = ref({
  visible: false,
})
const toShowMap = () => {
  mapConf.value.visible = true
}
const onMapChange = (mo: any) => {
  mapData.value = mo
  formRef.value.validateField('type')
}

const checkAll = ref(false)
const indeterminate = ref(false)

watch(
  () => formData.value.satelliteCodeList,
  (val) => {
    if (val.length === 0) {
      checkAll.value = false
      indeterminate.value = false
    } else if (val.length === satelliteList.value.length) {
      checkAll.value = true
      indeterminate.value = false
    } else {
      indeterminate.value = true
    }
  },
  {
    deep: true,
  }
)

const handleCheckAll = (val: any) => {
  indeterminate.value = false
  if (val) {
    formData.value.satelliteCodeList = satelliteList.value.map(
      (_: any) => _.satelliteCode
    )
  } else {
    formData.value.satelliteCodeList = []
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_drawer, {
      "model-value": props.visible,
      "destroy-on-close": "",
      title: "多星过境预测",
      size: "1000px",
      "before-close": handleClose,
      "label-position": "left"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleClose
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 关闭 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formData.value,
          rules: rules,
          class: "form ws_common_form",
          "label-width": 108
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "预报地点",
                      prop: "type"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formData.value.type,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.type) = $event)),
                          class: "ml-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, {
                              label: STATION_ENUM.STATION,
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("地面站")
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_radio, {
                              label: STATION_ENUM.CUSTOM,
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("地图")
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_1, [
                          (STATION_ENUM.STATION === formData.value.type)
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 0,
                                modelValue: formData.value.stationId,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.stationId) = $event)),
                                class: "ws_select"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictionaryList.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.stationId,
                                      label: item.stationName + ' ( ' + item.location + ' ) ',
                                      value: item.stationId
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(_unref(Text), {
                                  content: mapData.value.address,
                                  class: "ws_mr8"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(mapData.value.address), 1)
                                  ]),
                                  _: 1
                                }, 8, ["content"]),
                                _createVNode(_component_el_button, {
                                  plain: "",
                                  onClick: toShowMap
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("编辑地址")
                                  ]),
                                  _: 1
                                })
                              ]))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "卫星",
                      prop: "satelliteCode"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.value.satelliteCodeList,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.satelliteCodeList) = $event)),
                          class: "ws_select",
                          filterable: "",
                          multiple: "",
                          "collapse-tags": "",
                          "collapse-tags-tooltip": ""
                        }, {
                          header: _withCtx(() => [
                            _createVNode(_component_el_checkbox, {
                              modelValue: checkAll.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((checkAll).value = $event)),
                              indeterminate: indeterminate.value,
                              onChange: handleCheckAll
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 全选 ")
                              ]),
                              _: 1
                            }, 8, ["modelValue", "indeterminate"])
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(satelliteList.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.satelliteCode,
                                label: item.satelliteName + ' (' + item.satelliteCode + '）',
                                value: item.satelliteCode
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "时区",
                      prop: "timeZone"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.value.timeZone,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.timeZone) = $event)),
                          class: "ws_select",
                          clearable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(utcOps, (item) => {
                              return _createVNode(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "预报角度",
                      prop: "calculationElevation"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          class: "ws_select ws_left",
                          controls: false,
                          min: 1,
                          max: 90,
                          precision: 0,
                          modelValue: formData.value.calculationElevation,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.calculationElevation) = $event)),
                          modelModifiers: { number: true },
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "预报时间范围",
                      prop: "time"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: formData.value.time,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.time) = $event)),
                          type: "datetimerange",
                          placeholder: "请选择",
                          style: {"width":"100%"},
                          "value-format": "YYYY-MM-DD HH:mm:ss",
                          "range-separator": "-",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            plain: "",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode("开始预测")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_switch, {
              modelValue: detailFlag.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((detailFlag).value = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_6
          ]),
          _createVNode(_component_el_button, {
            plain: "",
            disabled: tableData.value.length === 0,
            onClick: exportTable
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("p", _hoisted_7, [
          _createTextVNode(" 总共"),
          _createElementVNode("span", null, _toDisplayString(tableData.value.length), 1),
          _createTextVNode("条 ")
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          class: "ws_common_table"
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, { description: "暂无数据" })
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
                key: item.prop
              }, { ...item }, { "show-overflow-tooltip": "" }), null, 16))
            }), 128))
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_unref(MapModal), {
      visible: mapConf.value.visible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((mapConf.value.visible) = $event)),
      data: mapData.value,
      onOnMapChange: onMapChange
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})